"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationValidation = void 0;
const OcppIdTokenAuthorizationSourceValidation_1 = require("./OcppIdTokenAuthorizationSourceValidation");
const OcppIdTokenAuthorizationStatusValidation_1 = require("./OcppIdTokenAuthorizationStatusValidation");
class OcppIdTokenAuthorizationValidation {
    static isValid(entity) {
        // Validate entity.payment_transaction_id for existence and correct type.
        if (entity.payment_transaction_id == undefined)
            return false;
        if (typeof entity.payment_transaction_id !== "string")
            return false;
        // Validate entity.payment_presented_timestamp for existence and correct type.
        if (entity.payment_presented_timestamp == undefined)
            return false;
        if (!(entity.payment_presented_timestamp instanceof Date))
            return false;
        // Validate entity.id_token for existence and correct type.
        if (entity.id_token == undefined)
            return false;
        if (typeof entity.id_token !== "string")
            return false;
        // If entity.port_id exists, validate that it has the correct type.
        if (entity.port_id != undefined) {
            if (typeof entity.port_id !== "number")
                return false;
        }
        // If entity.status exists, validate that it has the correct type.
        if (entity.status != undefined) {
            if (!OcppIdTokenAuthorizationStatusValidation_1.OcppIdTokenAuthorizationStatusValidation.isValid(entity.status))
                return false;
        }
        // If entity.resolved_via exists, validate that it has the correct type.
        if (entity.resolved_via != undefined) {
            if (!OcppIdTokenAuthorizationSourceValidation_1.OcppIdTokenAuthorizationSourceValidation.isValid(entity.resolved_via))
                return false;
        }
        return true;
    }
}
exports.OcppIdTokenAuthorizationValidation = OcppIdTokenAuthorizationValidation;
